import { Ref } from 'vue'

import { Column } from '~/ui/Table/types'

const useTableColumn = (targetColumn: Column[], exceptField: Ref<string[]>) => {
  const column = computed(() => {
    return targetColumn.filter((item) => {
      return !exceptField.value.includes(item.field)
    })
  })

  return {
    column
  }
}

const useTableRow = (targetRow: Ref<any[]>, activeIndexList: Ref<Set<number>>) => {
  const filteredRows = computed(() => {
    return targetRow.value.filter(row => row.isRoot || activeIndexList.value.has(row.index))
  })
  return { filteredRows }
}

export { useTableColumn, useTableRow }